import { TemplateData } from '../../types/blueprint'

export const getBlockFromTemplateData = (
  templateData: TemplateData,
  blockId: string
) => {
  let foundBlock = null
  templateData?.sections?.forEach((section) => {
    section.blockGroups.forEach((blockGroup) => {
      blockGroup.blocks.forEach((block) => {
        if (block.id === blockId) {
          foundBlock = block
        }
      })
    })
  })
  return foundBlock
}
